import api from './api';

/**
 * Remove um faturamento
 */
export const deletarFaturamento = async (id) => {
  const response = await api.delete(`/faturamento/${id}`);
  return response;
};

/**
 * Lista todos os faturamentos
 */
export const listarFaturamento = async () => {
  const response = await api.get('/faturamento');
  return response;
};

/**
 * Cria um novo faturamento
 */
export const criarFaturamento = async (faturamento) => {
  const response = await api.post('/faturamento', faturamento);
  return response;
};

/**
 * Atualiza um faturamento
 */
export const atualizarFaturamento = async (id, faturamento) => {
  const response = await api.put(`/faturamento/${id}`, faturamento);
  return response;
};

/**
 * Remove um faturamento
 */

/**
 * Emite Nota Fiscal para um faturamento
 */
export const emitirNotaFiscal = async (id) => {
  const response = await api.post(`/faturamento/${id}/emitir-nota`);
  return response;
};

/**
 * Reconsulta o status de uma nota que ficou "processando" (prefeitura mais lenta que o normal)
 */
export const statusNotaFiscal = async (id) => {
  const response = await api.get(`/faturamento/${id}/status-nota`);
  return response;
};

/**
 * Baixar recibo PF — obtém URL pré-assinada do S3 e abre no browser
 */
export const downloadReciboPF = async (id) => {
  const response = await api.get(`/faturamento/${id}/recibo`);
  const { url } = response;
  if (!url) throw new Error('URL do recibo não encontrada');
  window.open(url, '_blank', 'noopener,noreferrer');
};
